<template>
  <div v-cloak v-if="template" class="item-common pt-10 pb-15 px-7">
    <div class="header">
      <h1 class="title">{{ $t('역량기술서') }}</h1>
    </div>
    <div class="body">
      <v-form ref="form">
        <template v-for="(item, i) in abilityIntro">
          <v-row class="mt-8" v-if="item.yn === 'Y'" :key="'abilityIntro' + i">
            <v-col cols="12" style="font-weight: bold;">
              {{ $t(item.value) }}</v-col
            >
            <v-col cols="12" class="mt-2">
              <template v-if="isReadonly">
                <v-row>
                  <!-- style="box-shadow: none !important;" -->
                  <i-textarea
                    outlined
                    single-line
                    dense
                    readonly
                    auto-grow
                    :counter="item.limit"
                    v-model="item.desc"
                  ></i-textarea>
                </v-row>
              </template>
              <template v-else>
                <i-textarea
                  outlined
                  single-line
                  :label="getLabel(item.min, item.limit)"
                  v-model="item.desc"
                  dense
                  :counter="item.limit"
                  validate-on-blur
                  :rules="[
                    rules.required(item.name),
                    rules.maxlength(item.name),
                    rules.minlength(item.name),
                  ]"
                  :disabled="item.limit == 0"
                  @blur="save(i)"
                ></i-textarea>
              </template>
            </v-col>
          </v-row>
        </template>
      </v-form>
    </div>
  </div>
</template>

<script>
import { snack } from '@/plugins/dialog/api';
export default {
  props: {
    template: { type: Object },
    info: { type: Object },
    opts: { type: Object },
    rules: { type: Object },
    isReadonly: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
  },
  mounted() {
    this.setting();
  },
  data: () => ({
    abilityIntro: [],
    alert: false,
  }),
  methods: {
    setting: function() {
      this.abilityIntro = [];
      for (let i = 1; i <= 5; i++) {
        let preName = 'abilityIntro' + i;
        let lengthNm = preName + 'Length';
        let ynNm = preName + 'Yn';
        let MinlengthNm = preName + 'MinLength';
        let obj = {
          value: this.template[preName] ?? '',
          limit: this.template[lengthNm] ?? 0,
          min: this.template[MinlengthNm] ?? 0,
          yn: this.template[ynNm] ?? 'N',
          name: preName,
          desc: this.desc(preName),
        };

        this.abilityIntro.push(obj);
      }
    },
    desc: function(preName) {
      let desc = '';

      if (
        this.info &&
        this.info.abilityIntros &&
        this.info.abilityIntros.length > 0
      ) {
        this.info.abilityIntros.forEach(function(v) {
          if (v.id.cvColumn === preName) desc = v.abilityIntro;
        });
      }

      return desc;
    },
    replaceBr: function(contents) {
      if (contents == undefined || !contents) {
        return '';
      }

      contents = contents.replace(/\r\n/gi, '<br />');
      contents = contents.replace(/\n/gi, '<br />');

      return contents;
    },
    getLabel: function(min, max) {
      if (this.$i18n.locale === 'ko')
        return `최소 ${min} 최대 ${max} 자 내로 서술 해주세요.`;
      else if (this.$i18n.locale === 'en') return;
      `At least ${min} Up to ${max} Please describe it in words`;
    },
    valid: function() {
      return this.$refs.form.validate();
    },
    save: function(i) {
      const id = {
        annoId: this.$route.params.annoId,
        cvColumn: this.abilityIntro[i].name,
      };
      const p = {
        id: id,
        abilityIntro: this.abilityIntro[i].desc,
      };

      this.$emit('save', p, 'abilityIntro');
    },
    savecallback: function(res) {
      var v = this.template.abilityIntroTitle;
      if (res.status !== 200) {
        console.log('SELF INTRO SAVE FAIL');
      } else {
        snack.info(v + this.$t(' 저장완료'));
      }
    },
  },
};
</script>

<style>
.v-parallax {
  height: 100% !important;
}
.guide-common {
  min-height: calc(100vh - 64px - 122px);
}

.item-common .header .title {
  font-size: 18px;
  font-weight: bold;
  line-height: 2.67;
  letter-spacing: -0.36px;
  color: #292929;
}
.item-common .header .desc {
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: -0.28px;
  color: #555555;
}
.item-common .body {
  margin-top: 22px;
}
.item-common .body .v-divider {
  margin-top: 20px;
  margin-bottom: 20px;
}

.item-common .row {
  margin: 0px;
}
.item-common .col {
  padding: 0px;
}
.item-common .v-text-field {
  min-height: 36px;
}
.btn-post-wrap {
  position: relative;
}
.btn-post {
  position: absolute;
  top: 6px;
  right: 5px;
}

.abilityintro {
  padding: 12px !important;
  border-radius: 2px;
  border: 1px solid #999999;
}
</style>
